// extracted by mini-css-extract-plugin
export default {"bar":"SocialsBar_bar__OfMfO","socials":"SocialsBar_socials__fqXB9","icon":"SocialsBar_icon__kIV4b"};